import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  href = '#',
  className = ''
}: CTAButtonProps) {
  return <motion.a href={href} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        relative inline-flex items-center justify-center 
        px-8 py-4 text-lg md:text-xl font-bold text-white 
        bg-gold hover:bg-gold-light transition-colors duration-300
        rounded-full shadow-lg hover:shadow-xl
        overflow-hidden group
        ${className}
      `} data-id="element-163">
      <span className="relative z-10" data-id="element-164">{children}</span>
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-165" />
      {/* Subtle pulse ring */}
      <div className="absolute inset-0 rounded-full border-2 border-gold opacity-0 group-hover:animate-pulse-slow" data-id="element-166" />
    </motion.a>;
}